import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Grain, Ambient } from "@/components/site/Grain";
import Home from "@/pages/Home";
import PricingPage from "@/pages/PricingPage";
import FAQPage from "@/pages/FAQPage";
import SupportPage from "@/pages/SupportPage";
import LegalPage from "@/pages/LegalPage";
import { ComingSoonProvider } from "@/components/site/ComingSoon";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <ComingSoonProvider>
            <Grain />
            <Ambient />
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/privacy" element={<LegalPage slug="privacy" />} />
              <Route path="/terms" element={<LegalPage slug="terms" />} />
              <Route path="/refund" element={<LegalPage slug="refund" />} />
              <Route path="/cookie" element={<LegalPage slug="cookie" />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
          </ComingSoonProvider>
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
